import appCompany from "../../views/appFleet/company.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("company", {
    url: "company/:id",
    parent: "app",
    views: {
      view: {
        template: appCompany,
      },
    },
    data: { title: "Company" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/company/company.urls.js